import React, { Component } from 'react';
import { Stage, Layer } from 'react-konva';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Main from '../main';

import { 
  removeOP, 
  removeAPB, 
  removeFPB, 
  removeLUM,
  removeFDP, 
  removeFPL, 
  removePQ,
  removeFDS,
  removePL,
  removeFCR,
  removePT,
  removeDB,
  removeTCB } from '../actions/selectMedianMuscle';

import MedianNerveOne from './nerves/medianNerveOne';
import MedianNerveTwo from './nerves/medianNerveTwo';
import MedianNerveThree from './nerves/medianNerveThree';
import MedianNerveFour from './nerves/medianNerveFour';
import MedianNerveFiveOne from './nerves/medianNerveFiveOne';
import MedianNerveFiveTwo from './nerves/medianNerveFiveTwo';
import MedianNerveSix from './nerves/medianNerveSix';
import AiNerve from './nerves/aiNerve';
import PtNerve from './nerves/ptNerve';
import FcrNerve from './nerves/fcrNerve';
import PlNerve from './nerves/plNerve';
import FdpNerve from './nerves/fdpNerve';
import FdsNerve from './nerves/fdsNerve';
import FplNerve from './nerves/fplNerve';
import PqNerve from './nerves/pqNerve';
import TcBranch from './nerves/tcBranch';
import RmBranch from './nerves/rmBranch';
import LumBranch from './nerves/lumBranch';
import DigitalBranch from './nerves/digitalBranch';

import ProximalEntrapment from './nerves/proximalEntrapment';
import WristEntrapment from './nerves/wristEntrapment';
import AiEntrapment from './nerves/aiEntrapment';
import ForearmEntrapment from './nerves/forearmEntrapment';

import Cursor from '../cursor.js';

require('./index.css');

class MedianNerve extends Component {
  constructor() {
    super();
    if (window.innerWidth <= 1024) {
      this.state = {
        x: 0.6,
        y: 0.6,
        mobileY: 60,
        shadowNerveBlur: 0,
      }
    } else {
      this.state = {
        x: 0.85,
        y: 0.85,
        mobileY: -70,
        shadowNerveBlur: 15,
      }
    }
  }

  handleNerveMouseEnter = () => {
    this.props.removeOP(); 
    this.props.removeAPB(); 
    this.props.removeFPB(); 
    this.props.removeLUM();
    this.props.removeFDP(); 
    this.props.removeFPL(); 
    this.props.removePQ();
    this.props.removeFDS();
    this.props.removePL();
    this.props.removeFCR();
    this.props.removePT();
    this.props.removeDB();
    this.props.removeTCB();
  }

  render() {
    const { x, y, mobileY, shadowNerveBlur } = this.state;
    window.addEventListener("orientationchange", function(){ window.location.reload(); });
    
    return (
      <div>
        <Main />
        <Cursor />
        <h4 className='text'>Median Nerve</h4>
        <Stage width={window.innerWidth} height={window.innerHeight} draggable={true}>
          <Layer 
            offsetX={-150} 
            offsetY={mobileY} 
            className='nerve-layer' 
            scaleX={x} 
            scaleY={y}
            onTap={this.handleNerveMouseEnter}>
            <LumBranch shadowNerveBlur={shadowNerveBlur} />
            <DigitalBranch shadowNerveBlur={shadowNerveBlur} />
            <RmBranch shadowNerveBlur={shadowNerveBlur} />
            <TcBranch shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveOne shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveTwo shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveThree shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveFour shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveFiveOne shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveFiveTwo shadowNerveBlur={shadowNerveBlur} />
            <MedianNerveSix shadowNerveBlur={shadowNerveBlur} />
            <AiNerve shadowNerveBlur={shadowNerveBlur} />
            <PtNerve shadowNerveBlur={shadowNerveBlur} />
            <FcrNerve shadowNerveBlur={shadowNerveBlur} />
            <PlNerve shadowNerveBlur={shadowNerveBlur} />
            <FdpNerve shadowNerveBlur={shadowNerveBlur} />
            <FdsNerve shadowNerveBlur={shadowNerveBlur} />
            <FplNerve shadowNerveBlur={shadowNerveBlur} />
            <PqNerve shadowNerveBlur={shadowNerveBlur} />
            <ProximalEntrapment />
            <WristEntrapment />
            <ForearmEntrapment />
            <AiEntrapment />
          </Layer>
        </Stage>
      </div>
    );
  }
}

//-----Redux Functions-----
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeOP, 
                              removeAPB, 
                              removeFPB, 
                              removeLUM,
                              removeFDP, 
                              removeFPL, 
                              removePQ,
                              removeFDS,
                              removePL,
                              removeFCR,
                              removePT,
                              removeDB,
                              removeTCB }, 
   dispatch); 
};

export default connect(null, mapDispatchToProps)(MedianNerve);


// WEBPACK FOOTER //
// ./src/medianNerve/index.js